module.exports = __webpack_public_path__ + "__static/site-1768578553954/img/chicken-mobile-english.b641affd.jpg";